/* eslint-disable no-restricted-syntax */

import { OrderHistory } from './enums';

export interface Options {
  splitRegexp?: RegExp | RegExp[];
  stripRegexp?: RegExp | RegExp[];
  delimiter?: string;
  transform?: (part: string, index: number, parts: string[]) => string;
}

const DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];

const DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;

export function noCase(input: string, options: Options = {}) {
  const {
    splitRegexp = DEFAULT_SPLIT_REGEXP,
    stripRegexp = DEFAULT_STRIP_REGEXP,
    delimiter = ' ',
    transform = (str: string) => str.toLowerCase(),
  } = options;

  const result = replace(replace(input, splitRegexp, '$1\0$2'), stripRegexp, '\0');
  let start = 0;
  let end = result.length;

  // Trim the delimiter from around the output string.
  while (result.charAt(start) === '\0') start += 1;
  while (result.charAt(end - 1) === '\0') end -= 1;

  // Transform each token independently.
  return result.slice(start, end).split('\0').map(transform).join(delimiter);
}

/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input: string, re: RegExp | RegExp[], value: string) {
  if (re instanceof RegExp) return input.replace(re, value);
  return re.reduce((input1, re1) => input1.replace(re1, value), input);
}

export function upperCaseFirst(input: string) {
  return input.charAt(0).toUpperCase() + input.substring(1);
}

export function sentenceCaseTransform(input: string, index: number) {
  const result = input.toLowerCase();
  if (index === 0) return upperCaseFirst(result);
  return result;
}

export function sentenceCase(input: string, options: Options = {}) {
  return noCase(input, {
    delimiter: ' ',
    transform: sentenceCaseTransform,
    ...options,
  });
}

export const currentFormat = (value = 0) =>
  new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);

export function merge(...objects: any) {
  const merged: any = {};

  for (const obj of objects) {
    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          if (Array.isArray(obj[key])) {
            if (Array.isArray(merged[key])) {
              merged[key] = merged[key].concat(obj[key]);
            } else {
              merged[key] = [...obj[key]];
            }
          } else {
            merged[key] = merge(merged[key], obj[key]);
          }
        } else {
          merged[key] = obj[key];
        }
      }
    }
  }

  return merged;
}

export const invalidateOrders = {
  history: [OrderHistory.ROOT],
  open: [OrderHistory.ROOT, OrderHistory.OPEN],
  close: [OrderHistory.ROOT, OrderHistory.OPEN],
};
